export default __webpack_public_path__ + "static/logo-icon-3ec410c448a00cb46bee52ac1472b49f.png";